import { render } from "./index2.vue?vue&type=template&id=daa6d9fc&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"

import "./index2.vue?vue&type=style&index=0&id=daa6d9fc&lang=less&scoped=true"

import exportComponent from "E:\\Voyager_Project\\SourceCode\\Front_End\\dev_version_Voyager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa6d9fc"]])

export default __exports__